import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
// import { service } from '@/plugin/axios'
import { service } from '../service';
import store from '@/store/index';

var Helper = /*#__PURE__*/function () {
  function Helper(controllerName, otherService, method) {
    _classCallCheck(this, Helper);

    this.controllerName = controllerName;
    this.service = otherService;
    this.method = method;
  }

  _createClass(Helper, [{
    key: "LoadData",
    value: function LoadData() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var customRoute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

      if (query.ParamList) {
        query.ParamList.forEach(function (u) {
          if (typeof u.PARAM_VALUE === 'number') {
            u.PARAM_VALUE = u.PARAM_VALUE.toString();
          }
        });
      } // console.log('store.getters.routerPath',store.getters.routerPath);


      return this.service[this.method](this.controllerName, _objectSpread({
        LIST_ROUTE: customRoute || store.getters.routerPath
      }, query));
    }
  }]);

  return Helper;
}();

export default function (controllerName, otherService) {
  var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'post';
  otherService = otherService || service;
  var helper = new Helper(controllerName, otherService, method);
  return helper;
}